import { useState } from "react";

import { CartState } from "../../utils/interfaces/cart";
import constants from "./constants.json";
import edit from "../../assets/images/edit.svg";
import up from "../../assets/images/up.svg";
import { Item } from "../../utils/interfaces/cart";
import PackageInformationView, { PackageInfoState } from "./packageView";
import UserInformationView, { UserDetailsState } from "./userInformation";
interface UserDetailsProps {
  cartData: CartState;
  setAdminForm: (res: boolean) => void;
}

const UserDetails = (props: UserDetailsProps) => {
  const { cartData, setAdminForm } = props;
  const [showAdminFromDetails, setShowAdminFromDetails] = useState(true);
  const [showPackages, setShowPackages] = useState(true);

  const editAdminForm = () => {
    setAdminForm(true);
  };

  const setPackageInformation = (items: Array<Item>) => {
    const arr = [] as Array<PackageInfoState>;
    items.map((item: Item) => {
      if (item.product)
        arr.push({
          name: item.product.name,
          description: item?.product?.short_description?.html,
          features: item?.product?.ln_sl_inclusion_overview
            ? item?.product?.ln_sl_inclusion_overview.split(",")
            : [],
        });
    });
    return arr;
  };

  const setUserInformation = () => {
    const obj = {} as UserDetailsState;
    obj.firstname = cartData.billing_address?.firstname || "";
    obj.lastname = cartData.billing_address?.lastname || "";
    obj.email = cartData.email || "";
    obj.telephone = cartData.billing_address?.telephone || "";
    obj.jobTitle = cartData.custom_attributes.ln_job_title || "";
    obj.street = cartData.billing_address?.street.join(", ") || "";
    obj.city = cartData.billing_address?.city || "";
    obj.region = cartData.billing_address?.region.label || "";
    obj.postcode = cartData.billing_address?.postcode || "";
    obj.lnfe = cartData.ln_fe || [];
    obj.attorneySize = cartData.custom_attributes.ln_sl_noattorney || 1;
    return obj;
  };

  return props.cartData.billing_address ? (
    <div className="w-full lg:w-[55%] mr-6">
      <div className="saved-details-container mb-6">
        <div className="flex justify-between w-full">
          <div className="flex items-baseline">
            <h1 className="text-xl font-semibold mb-2 mr-2">
              {constants.formSection.heading}
            </h1>
            <button data-track="edit-button" onClick={editAdminForm}>
              <img src={edit} alt="Edit" />
            </button>
          </div>
          <button
            data-track="arrow-icon"
            onClick={() => setShowAdminFromDetails(!showAdminFromDetails)}
          >
            <img
              className={showAdminFromDetails ? "" : "rotate-180"}
              src={up}
              alt="arrow"
            />
          </button>
        </div>
        {showAdminFromDetails && UserInformationView(setUserInformation())}
      </div>
      <div className="saved-details-container">
        <div className="flex justify-between w-full">
          <h1 className="text-xl font-semibold mb-2 mr-2">
            Package Information
          </h1>
          <button
            data-track="arrow-icon"
            onClick={() => setShowPackages(!showPackages)}
          >
            <img
              className={showPackages ? "" : "rotate-180"}
              src={up}
              alt="arrow"
            />
          </button>
        </div>
        {showPackages &&
          PackageInformationView(setPackageInformation(cartData.items))}
      </div>
    </div>
  ) : (
    <div>Loading...</div>
  );
};

export default UserDetails;
